export enum ListingType {
  BUY = 'buy',
  RENT = 'rent'
}
